module.exports = __webpack_public_path__ + "img/scene_movie.fe69b836.webp";